<template>
  <div>
    <el-form ref="form" size="small" :model="formData">
      <el-row :gutter="20" class="mt-3">
        <el-col :span="8">
          <el-form-item :label="$l('form_label_salesChannel') || '销售渠道'">
            <el-input v-model="formData.salesChannel" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_orderNo') || '订单编号'"
            prop="orderNo"
          >
            <el-input v-model="formData.orderNo" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_customerOrderNo') || '客户订单编号'"
            prop="customerOrderNo"
          >
            <el-input v-model="formData.customerOrderNo" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_orderDate') || '下单时间'"
            prop="orderDate"
          >
            <el-input v-model="formData.v_orderDate" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_created') || '系统订单'"
            prop="orderDate"
          >
            <el-input v-model="formData.v_created" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_shipped') || '订单发货'"
            prop="orderDate"
          >
            <el-input v-model="formData.v_shipped" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_data') || '订单原始数据'"
            prop="data"
          >
            <el-input
              v-model="formData.data"
              readonly
              type="textarea"
              rows="5"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_warehouseData') || '仓库订单数据'"
            prop="warehouseData"
          >
            <el-input
              v-model="formData.warehouseData"
              readonly
              type="textarea"
              rows="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    platformOrderCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.platformOrderCode) return
      this.$api
        .ecomPlatformOrderDetailApi({
          platformOrderCode: this.platformOrderCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
</style>
